
import $ from 'jquery';

$(document).ready(function () {

    update_cart_thumbs();

    if (window.location.href.indexOf('order-mottagen') !== -1) {
        for (var i = 0; i < localStorage.length; i++) {
            if (localStorage.key(i).startsWith('thumb_')) {
                localStorage.removeItem(localStorage.key(i));
            }
        }
    }
});

$(document).on('updated_wc_div', function () {
    update_cart_thumbs();
});

function update_cart_thumbs() {
    $('[data-visualizer-thumb]').each(function (i, el) {
        var id = $(this).attr('data-visualizer-thumb');
        var svg = localStorage.getItem('thumb_' + id);
        if (svg) {
            $(this).after(svg);
            $(this).hide();
        }
    });
}

